export default "__VITE_ASSET__nDjnBHz1__"